import { supabase } from '@/lib/supabase/supabaseClient';
import { GetSingleSurveyFromBankProps } from '.';
import { groupQuestionsByDependencies } from '@/features/question/hooks/useQuery/useGetQuestionsBySurveyId/utils/groupQuestionsByDependencies';

export const getSingleSurveyFromBank = async ({
  surveyId,
}: GetSingleSurveyFromBankProps) => {
  return await supabase
    .from('survey_bank')
    .select(
      `
            *,
            author:user(*),
            survey_bank_question_bank(*)
            `
    )
    .order('id', { ascending: true })
    .eq('id', surveyId)
    .throwOnError()
    .then((res) => res.data)
    .then((data) => {
      if (!data) return undefined;
      const resWithGroupedQuestions = data.map((res) => {
        return {
          ...res,
          questions: {
            grouped: groupQuestionsByDependencies(
              res.survey_bank_question_bank
            ),
            questions: res.survey_bank_question_bank,
          },
        };
      });
      return resWithGroupedQuestions?.[0];
    });
};
